(function () {
  var selector = '[data-item-manager-catch-icons-product-code]';
  var defaultApiBaseUrl = 'https://admin.e-asakura.net';
  var cacheTtl = 5 * 60 * 1000;
  var staleTtl = 30 * 60 * 1000;

  function getUtils() {
    return window.ItemManagerThemeUtils || null;
  }

  function normalizeCode(value) {
    return String(value || '').trim();
  }

  function normalizeColor(value, fallback) {
    var color = String(value || '').trim();
    return /^#[0-9a-f]{6}$/i.test(color) ? color : fallback;
  }

  function buildUrl(apiBaseUrl) {
    try {
      return new URL('/api/public/en-neume/catch-icons', apiBaseUrl).toString();
    } catch (error) {
      return null;
    }
  }

  function readCachedPayload(cacheKey) {
    var utils = getUtils();
    if (!utils || typeof utils.readJsonCache !== 'function') return null;
    return utils.readJsonCache({
      key: cacheKey,
      cacheTtl: cacheTtl,
      staleTtl: staleTtl
    });
  }

  function writeCachedPayload(cacheKey, payload) {
    var utils = getUtils();
    if (!utils || typeof utils.writeJsonCache !== 'function') return;
    utils.writeJsonCache({
      key: cacheKey,
      payload: payload
    });
  }

  function fetchPayload(apiBaseUrl) {
    var url = buildUrl(apiBaseUrl);
    if (!url) return Promise.resolve(null);

    var cacheKey = 'item-manager-catch-icons:v2:' + url;
    var cached = readCachedPayload(cacheKey);
    if (cached && cached.isFresh) return Promise.resolve(cached.payload);

    var utils = getUtils();
    if (utils && typeof utils.preconnect === 'function') {
      utils.preconnect(apiBaseUrl, 'item-manager-catch-icons');
    }

    return fetch(url, {
      credentials: 'omit',
      headers: { Accept: 'application/json' },
      priority: 'low'
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Failed to load catch icons');
        return response.json();
      })
      .then(function (payload) {
        writeCachedPayload(cacheKey, payload);
        return payload;
      })
      .catch(function () {
        return cached ? cached.payload : null;
      });
  }

  function renderIcon(icon) {
    var label = document.createElement('span');
    label.className = 'eb_catch_icon';
    label.textContent = String(icon && icon.title || '').trim();
    label.style.color = normalizeColor(icon && icon.fontColor, '#ffffff');
    label.style.backgroundColor = normalizeColor(icon && icon.backgroundColor, '#616161');
    return label;
  }

  function resolveIcons(target, payload) {
    var productCode = normalizeCode(target.dataset.itemManagerCatchIconsProductCode);
    var rules = window.ItemManagerCatchIconRules;

    // 判定は一覧カードと共通のファイルに置いている。読み込みに失敗したときは
    // 手動設定ぶんだけを出す（自動表示が出ないだけで、既存の表示は壊れない）。
    if (!rules || typeof rules.resolve !== 'function') {
      var productIcons = (payload && payload.productIcons) || {};
      return Array.isArray(productIcons[productCode]) ? productIcons[productCode] : [];
    }

    return rules.resolve({
      payload: payload,
      productCode: productCode,
      minStock: target.dataset.minStock,
      hasPreorder: target.dataset.preorder === 'true'
    });
  }

  function renderTargets(targets, payload) {
    targets.forEach(function (target) {
      var icons = resolveIcons(target, payload);
      var existing = target.querySelector(':scope > .eb_icon_box[data-item-manager-catch-icons]');

      if (existing) existing.remove();

      if (!icons.length) {
        return;
      }

      var box = document.createElement('div');
      box.className = 'eb_icon_box';
      box.setAttribute('data-item-manager-catch-icons', '');

      icons.forEach(function (icon) {
        if (icon && icon.title) box.appendChild(renderIcon(icon));
      });

      if (box.children.length) target.insertBefore(box, target.firstChild);
    });
  }

  function boot() {
    var targets = Array.prototype.slice.call(document.querySelectorAll(selector))
      .filter(function (target) {
        return normalizeCode(target.dataset.itemManagerCatchIconsProductCode);
      });

    if (!targets.length) return;

    var apiBaseUrl = targets[0].dataset.itemManagerCatchIconsApiBaseUrl || defaultApiBaseUrl;
    fetchPayload(apiBaseUrl).then(function (payload) {
      if (payload) renderTargets(targets, payload);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
